import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "../ThemeContext";
import { FiSun, FiMoon, FiMenu, FiX, FiAward, FiInfo, FiLogIn, FiLogOut, FiFileText, FiShield, FiZap, FiTarget } from "react-icons/fi";
import "./Navbar.css";

const Navbar = ({ user, setUser }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [mobileMenuOpen]);
  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("zft_user");
    setUser(null);
    navigate("/");
    setMobileMenuOpen(false);
  };

  const close = () => setMobileMenuOpen(false);
  const isActive = (path) => location.pathname === path;
  const isAdmin = user && (user.role === "admin" || user.role === "super_admin");
  const isLoginPage = location.pathname === "/login";

  return (
    <>
      <nav className={`navbar${isLoginPage ? " navbar-hidden" : ""}`}>
        <div className="navbar-container">
          {/* Logo */}
          <Link to="/" className="navbar-brand">
            <div className="brand-icon">ZFT</div>
          </Link>

          {/* Desktop Navigation */}
          <div className="navbar-menu">
            <Link to="/" className={`nav-link ${isActive("/") ? "active" : ""}`}>
              <FiInfo size={18} /><span>About</span>
            </Link>
            <Link to="/fight-club" className={`nav-link ${isActive("/fight-club") ? "active" : ""}`}>
              <FiZap size={18} /><span>Fight Club</span>
            </Link>
            <Link to="/zombs-royale" className={`nav-link ${isActive("/zombs-royale") ? "active" : ""}`}>
              <FiTarget size={18} /><span>ZombsRoyale</span>
            </Link>
            <Link to="/tournaments" className={`nav-link ${isActive("/tournaments") ? "active" : ""}`}>
              <FiAward size={18} /><span>Tournaments</span>
            </Link>
            {isAdmin && (
              <>
                <Link to="/logs" className={`nav-link ${isActive("/logs") ? "active" : ""}`}>
                  <FiFileText size={18} /><span>Logs</span>
                </Link>
                <Link to="/admin" className={`nav-link ${isActive("/admin") ? "active" : ""}`}>
                  <FiShield size={18} /><span>Admin</span>
                </Link>
              </>
            )}
          </div>

          {/* Right Side Actions */}
          <div className="navbar-actions">
            <button onClick={toggleTheme} className="btn btn-ghost btn-icon theme-toggle" aria-label="Toggle theme">
              {isDark ? <FiSun size={20} /> : <FiMoon size={20} />}
            </button>

            {user ? (
              <div className="user-menu">
                <span className="user-name">{user.username}</span>
                <button onClick={handleLogout} className="btn btn-secondary">
                  <FiLogOut size={18} /><span>Logout</span>
                </button>
              </div>
            ) : (
              <Link to="/login" className="btn btn-primary">
                <FiLogIn size={18} /><span>Login</span>
              </Link>
            )}

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="mobile-menu-toggle btn btn-ghost btn-icon"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile overlay — rendered outside <nav> so position:fixed isn't broken by nav's transform */}
      {!isLoginPage && (
        <div className={`mobile-menu${mobileMenuOpen ? " is-open" : ""}`}>
          <Link to="/" onClick={close} className={`mobile-nav-link ${isActive("/") ? "active" : ""}`}>
            <FiInfo size={20} /><span>About</span>
          </Link>
          <Link to="/fight-club" onClick={close} className={`mobile-nav-link ${isActive("/fight-club") ? "active" : ""}`}>
            <FiZap size={20} /><span>Fight Club</span>
          </Link>
          <Link to="/zombs-royale" onClick={close} className={`mobile-nav-link ${isActive("/zombs-royale") ? "active" : ""}`}>
            <FiTarget size={20} /><span>ZombsRoyale</span>
          </Link>
          <Link to="/tournaments" onClick={close} className={`mobile-nav-link ${isActive("/tournaments") ? "active" : ""}`}>
            <FiAward size={20} /><span>Tournaments</span>
          </Link>
          {isAdmin && (
            <>
              <Link to="/logs" onClick={close} className={`mobile-nav-link ${isActive("/logs") ? "active" : ""}`}>
                <FiFileText size={20} /><span>Logs</span>
              </Link>
              <Link to="/admin" onClick={close} className={`mobile-nav-link ${isActive("/admin") ? "active" : ""}`}>
                <FiShield size={20} /><span>Admin Dashboard</span>
              </Link>
            </>
          )}

          {user ? (
            <>
              <div className="mobile-user-info">
                <span className="label">Logged in as</span>
                <span className="username">{user.username}</span>
              </div>
              <button onClick={handleLogout} className="mobile-nav-link">
                <FiLogOut size={20} /><span>Logout</span>
              </button>
            </>
          ) : (
            <Link to="/login" onClick={close} className="mobile-nav-link">
              <FiLogIn size={20} /><span>Login</span>
            </Link>
          )}
        </div>
      )}
    </>
  );
};

export default Navbar;
